export default __webpack_public_path__ + "static/media/logo_transparent_white.30a192c8.png";